import { z } from 'zod';

export const AdFormResponseSchema = z.object({
  isBothSidesIntegration: z.boolean().optional(),
  count: z.object({
    adServer: z.number(),
  }),
  integrations: z.array(
    z.object({
      id: z.number(),
      name: z.string(),
      advertiser: z.number().nullable(),
      integrationType: z.literal('ad_server'),
      isActive: z.boolean(),
      platform: z.literal('adform'),
    }),
  ),
});

export const CmIntegrationsResponseSchema = z.object({
  isBothSidesIntegration: z.boolean(),
  count: z.object({
    adServer: z.number(),
  }),
  integrations: z.array(
    z.object({
      id: z.number(),
      name: z.string(),
      account: z.number().nullable(),
      profileId: z.number(),
      integrationType: z.literal('ad_server'),
      platform: z.literal('campaign_manager'),
      dv360Linkage: z.boolean(),
      advertiserIds: z.array(z.number().or(z.string())),
      attributionModelId: z.string().nullable(),
      isActive: z.boolean(),
      isOauthConnected: z.boolean(),
    }),
  ),
});

export type CmIntegrations = z.infer<typeof CmIntegrationsResponseSchema>;

export const AdFormOptionsResponseSchema = z.object({
  clientId: z.string(),
  redirectUri: z.string(),
  responseType: z.string(),
  scope: z.string(),
  state: z.string(),
});
